export default __webpack_public_path__ + "static/media/I0000.ef00dc21.png";